import style from './TableItem.module.css'
import {ReactComponent as Correct} from '../../Assets/icons/Correct.svg'
import { useMemo } from 'react'

const getColor = (correction) => {
    if(correction > 0){
        return 'green'
        return '#33CC33'
    } else if (correction < 0){
        return 'red'
        return '#F0142F'
    } else {
        return ''
        return '#ff931e'
    }
}

export function TableItem({data}) {

    const stoks = useMemo(() => data.stocks.reduce((acc, item) => acc + item.stock, 0))
    const color = getColor(data.price_correction)
    
    return <div className={style.tableItem}>
        <div className={`${style.title} tableItem__title`}>
            <h2 className={style.maker} onClick={() => window.open(data.cable_url, '_blank')} >{data.alias_name}</h2>
            <p className={style.market}>{data.vendor_name}</p>
        </div>
        <div className={style.correction}>
            <Correct fill={color === 'green' ? '#33CC33' :color === 'red' ? '#F0142F' : '#ff931e' } stroke={color === 'green' ? '#33CC33' :color === 'red' ? '#F0142F' : '#ff931e' } /> 
            <p className={`${style.correction__text} ${style[getColor(data.price_correction)]}`}>{data.price_correction > 0 && '+'}{data.price_correction}</p>
        </div>
        <p className={style.price}>{data.price}</p>

         <div className={style.stoksIndicator} style={{position: 'static', width: '100%'}}>
            
            {stoks > 0 
                ? <div className={style.indicatorBlock} style={{backgroundColor: '#33CC33'}}></div>
                : <div className={style.indicatorBlock} style={{backgroundColor: '#EE3B3B'}}></div>
            }
            <div className={style.stoksCount}>{stoks} м</div>
        </div>
    </div>
}